import Form from "./Form";
export default class Ares {

    static init() {
        var icoInputs = document.getElementsByClassName('input-ico');
        var icoButtons = document.getElementsByClassName('ares-load');

        if(icoInputs.length > 0) {
            icoInputs.forEach(input => {
                input.addEventListener('change', () => {
                    let val = input.value;

                    Ares.processAresRequest(val);
                });
            });
        }

        if(icoButtons.length > 0) {
            icoButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    let val = icoInputs.item(0).value;

                    Ares.processAresRequest(val);
                })
            });
        }
    }

    static processAresRequest(val) {
        let xhr = new XMLHttpRequest();
        xhr.open("POST", '/ares/data/'+val, true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onreadystatechange = function() { // Call a function when the state changes.
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                let result = (JSON.parse(this.response));
                if(result.error) {
                    alert(result.error);
                } else {
                    document.getElementsByClassName('input-dic').forEach(input => {
                        input.value = result.result.dic;
                    });
                    document.getElementsByClassName('input-company').forEach(input => {
                        input.value = result.result.company;
                    });
                    document.getElementsByClassName('input-city').forEach(input => {
                        input.value = result.result.city;
                    });
                    document.getElementsByClassName('input-zip').forEach(input => {
                        input.value = result.result.zip;
                    });
                    document.getElementsByClassName('input-street').forEach(input => {
                        input.value = result.result.street;
                    });
                    Form.handleFixedLabel();
                }
            }
        }
        xhr.send();
    }
}
